import React, { useEffect, useState } from 'react';
import SuperAdminLayout from '../../layouts/SuperAdminLayout';
import { Box, Typography, Grid, Card, CardContent } from '@mui/material';
import api from '../../services/api';
import NotificationSnackbar from '../../components/NotificationSnackbar';

// This dashboard now just renders children, all logic is in AdminDashboard.js
function SuperAdminDashboard({ children }) {
  return (
    <SuperAdminLayout>
      {children}
    </SuperAdminLayout>
  );
}

export default SuperAdminDashboard;
